import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { TranslateService } from '@ngx-translate/core';
import { forEach } from '@angular/router/src/utils/collection';
import { count } from 'console';

@Component({
  selector: 'app-flight',
  templateUrl: './flight.component.html',
  styleUrls: ['./flight.component.css']
})
export class FlightComponent implements OnInit {
  
  model = {
    'table_name': 'flight', 'flight_id': '0', 'flight_no': '', 'flight_name': '', 'flight_number': '',
    'start_airport': '0', 'end_airport': '0', 'depart_time': '', 'arrival_time': '', 'flight_start_date': '',
    'flight_end_date': '', 'flight_day': '', 'flight_date': '', 'restriction': '', 'ticket_num': '', 
    'airline_id': '', 'return_required': '0', 'adult_price': '0', 'adult_group_price': '0', 'child_price': '0', 
    'child_group_price': '0', 'infant_price': '0', 'infant_group_price': '0', 'return_perc': '0', 
    'return_group_perc': '0', 'cost_center': '0', 'comment': ''
  };

  cc_model = {
    'table_name': 'cost_center', 'cc_id': '0', 'cc_number': '', 'cc_name': '', 'cc_name_en': '', 
    'cc_desc': '', 'flag': 'new', 'key': 'cc_id', 'comment': ''
  };

  search_airport = {
    'placeholder': 'اسم المطار', 'class_name': 'tdSearchField',
    'table_list': [{
      'table_name': 'airport', 'selected_no': 'airport_id',
      'field_list': ['airport_name', 'airport_name_en', 'airport_code']
    }]
  };

  search_airline = {
    'placeholder': 'اسم الشركة', 'class_name': 'tdSearchField',
    'table_list': [{
      'table_name': 'airline', 'selected_no': 'airline_id',
      'field_list': ['airline_name', 'airline_name_en']
    }]
  };

  data_model = {
    'dep_time_hr': '', 'dep_time_mm': '', 'dep_time_per': '', 'arr_time_hr': '', 'arr_time_mm': '', 
    'arr_time_per': '', 'flight_start_date': new Date(), 'flight_end_date': new Date()
  };

  from_airport_detail = '';
  to_airport_detail = '';
  airline_detail = '';

  hour_list = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
  min_list = [];
  period_list = [{ 'period': 'AM', 'period_ar': 'صباحاً' }, { 'period': 'PM', 'period_ar': 'مساءاً' }];

  flight_no = "";
  flight_list = [];
  cc_list = [];

  //Translate:
  Airport_Placeholder; Airline_Name;
  Flight_Name_Msg; Flight_Number_Msg; Start_Airport_Msg; 
  End_Airport_Msg; Depart_Time_Msg; Arrival_Time_Msg;
  Start_Date_Msg; End_Date_Msg; Operating_Days_Msg;
  Ticket_Num_Msg; Adult_Price_Msg; Child_Price_Msg; Infant_Price_Msg;
  Success_Msg; Error_Msg;

  constructor(private utils: Utils, public applicationConstants: ApplicationConstants,
    private queryList: QueryList, private route: ActivatedRoute, private router: Router,
    public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Airport').subscribe((res: string) => {
      this.Airport_Placeholder = res;
    });
    this.search_airport['placeholder'] = this.Airport_Placeholder;
    
    translate.get('Airline_Name').subscribe((res: string) => {
      this.Airline_Name = res;
    });
    this.search_airline['placeholder'] = this.Airline_Name;
    
    translate.get('Flight_Name_Msg').subscribe((res: string) => {
      this.Flight_Name_Msg = res;
    });

    translate.get('Flight_Number_Msg').subscribe((res: string) => {
      this.Flight_Number_Msg = res;
    });

    translate.get('Start_Airport_Msg').subscribe((res: string) => {
      this.Start_Airport_Msg = res;
    });

    translate.get('End_Airport_Msg').subscribe((res: string) => {
      this.End_Airport_Msg = res;
    });

    translate.get('Depart_Time_Msg').subscribe((res: string) => {
      this.Depart_Time_Msg = res;
    });

    translate.get('Arrival_Time_Msg').subscribe((res: string) => {
      this.Arrival_Time_Msg = res;
    });

    translate.get('Start_Date_Msg').subscribe((res: string) => {
      this.Start_Date_Msg = res;
    });

    translate.get('End_Date_Msg').subscribe((res: string) => {
      this.End_Date_Msg = res;
    });

    translate.get('Operating_Days_Msg').subscribe((res: string) => {
      this.Operating_Days_Msg = res;
    });

    translate.get('Ticket_Num_Msg').subscribe((res: string) => {
      this.Ticket_Num_Msg = res;
    });

    translate.get('Adult_Price_Msg').subscribe((res: string) => {
      this.Adult_Price_Msg = res;
    });

    translate.get('Child_Price_Msg').subscribe((res: string) => {
      this.Child_Price_Msg = res;
    });

    translate.get('Infant_Price_Msg').subscribe((res: string) => {
      this.Infant_Price_Msg = res;
    });
    
    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });
  }

  ngOnInit() {
    this.min_list = [];
    for (let index = 0; index < 60; index++) {
      if (index < 10)
        this.min_list.push('0' + index);
      else 
        this.min_list.push(index.toString());
    }

    this.route.params.subscribe(params => {
      if (params['no'] != undefined) {
        this.flight_no = params['no'];

        // get flight detail
        let query = "SELECT `flight`.*, `airport`.`airport_name`, `airport`.`airport_name_en`, " + 
          "`airport`.`airport_code`, (CASE WHEN `flight`.`airline_id` != '0' THEN " + 
          "(SELECT `airline`.`airline_name` FROM `airline` WHERE `airline`.`airline_id` = `flight`.`airline_id`) " + 
          "ELSE '' END) AS 'airline_name', (CASE WHEN `flight`.`airline_id` != '0' THEN " + 
          "(SELECT `airline`.`airline_name_en` FROM `airline` WHERE " + 
          "`airline`.`airline_id` = `flight`.`airline_id`) ELSE '' END) AS 'airline_name_en' FROM `flight`, " + 
          "`airport` WHERE `flight`.`flight_no` = '" + this.flight_no + "' AND " + 
          "`flight`.`status` = '1' AND `flight`.`start_airport` = `airport`.`airport_id`";
        let obj = { cmd: 'getList', query: query };

        this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
          .subscribe(data => {
            this.applicationConstants.appComp.hideBusyCursor();

            this.flight_list = data.data['list'];
            
            this.model['flight_id'] = this.flight_list[0]['flight_id'];
            this.model['flight_no'] = this.flight_list[0]['flight_no'];
            this.model['flight_number'] = this.flight_list[0]['flight_number'];
            this.model['flight_name'] = this.flight_list[0]['flight_name'];

            this.model['start_airport'] = this.flight_list[0]['start_airport'];
            this.from_airport_detail = this.flight_list[0]['airport_name'] + " - " + 
              this.flight_list[0]['airport_name_en'] + " - " + this.flight_list[0]['airport_code'];

            this.model['end_airport'] = this.flight_list[0]['end_airport'];
            // get end aiprot detail
            query = "SELECT * FROM `airport` WHERE `airport_id` = '" + this.model['end_airport'] + "'";
            obj = { cmd: 'getList', query: query };
            this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
              .subscribe(data => {
                this.applicationConstants.appComp.hideBusyCursor();

                let reuslt = data.data['list'];
                this.to_airport_detail = reuslt[0]['airport_name'] + " - " + 
                  reuslt[0]['airport_name_en'] + " - " + reuslt[0]['airport_code'];
              });

            this.model['depart_time'] = this.flight_list[0]['depart_time'];
            this.data_model['dep_time_hr'] = this.flight_list[0]['depart_time'].substring(0, 2);
            this.data_model['dep_time_mm'] = this.flight_list[0]['depart_time'].substring(3, 5);
            this.data_model['dep_time_per'] = this.flight_list[0]['depart_time'].substring(6);

            this.model['arrival_time'] = this.flight_list[0]['arrival_time'];
            this.data_model['arr_time_hr'] = this.flight_list[0]['arrival_time'].substring(0, 2);
            this.data_model['arr_time_mm'] = this.flight_list[0]['arrival_time'].substring(3, 5);
            this.data_model['arr_time_per'] = this.flight_list[0]['arrival_time'].substring(6);

            this.model['flight_start_date'] = this.flight_list[0]['flight_start_date'];
            this.data_model['flight_start_date'] = new Date(this.model['flight_start_date']);
            this.model['flight_end_date'] = this.flight_list[0]['flight_end_date'];
            this.data_model['flight_end_date'] = new Date(this.model['flight_end_date']);

            this.model['flight_day'] = this.flight_list[0]['flight_day'];
            // get the operating days
            query = "SELECT DISTINCT `flight_day` FROM `flight` WHERE `flight_no` = '" + this.flight_no + 
              "' AND `status` = '1'";
            obj = { cmd: 'getList', query: query };
            
            this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
              .subscribe(data => {
                this.applicationConstants.appComp.hideBusyCursor();

                let reuslt = data.data['list'];
                reuslt.forEach(element => {
                  (document.getElementById('chx_' + (element.flight_day).toLowerCase()) as HTMLInputElement).checked = true;
                });
              });

            this.model['flight_date'] = this.flight_list[0]['flight_date'];
            this.model['restriction'] = this.flight_list[0]['restriction'];
            this.model['ticket_num'] = this.flight_list[0]['ticket_num'];

            this.model['airline_id'] = this.flight_list[0]['airline_id'];
            this.airline_detail = this.flight_list[0]['airline_name'] + " - " + 
              this.flight_list[0]['airline_name_en'] ;

            this.model['return_required'] = this.flight_list[0]['return_required'];
            (document.getElementById('return_required') as HTMLInputElement).checked = (this.model['return_required'] == '1');

            this.model['adult_price'] = this.flight_list[0]['adult_price'];
            this.model['adult_group_price'] = this.flight_list[0]['adult_group_price'];
            this.model['child_price'] = this.flight_list[0]['child_price'];
            this.model['child_group_price'] = this.flight_list[0]['child_group_price'];
            this.model['infant_price'] = this.flight_list[0]['infant_price'];
            this.model['infant_group_price'] = this.flight_list[0]['infant_group_price'];
            this.model['return_perc'] = this.flight_list[0]['return_perc'];
            this.model['return_group_perc'] = this.flight_list[0]['return_group_perc'];
            this.model['cost_center'] = this.flight_list[0]['cost_center'];
            this.model['comment'] = this.flight_list[0]['comment'];

            // get the cost center list by flight no
            query = "SELECT `cost_center`.* FROM `cost_center`, `flight` WHERE " + 
              "`cost_center`.`cc_id` = `flight`.`cost_center` AND `cost_center`.`status` = '1' AND " + 
              "`flight`.`flight_no` = '" + this.flight_no + "'";
            obj = { cmd: 'getList', query: query };
          
            this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
              .subscribe(data => {
                this.applicationConstants.appComp.hideBusyCursor();
                this.cc_list = data.data['list'];
              });
          });
      }
    });
  }

  onChangeFromAirport = function (search_result: object) {
    this.model['start_airport'] = (search_result['no'] != '' ? search_result['no'] : '0');
  }

  onChangeToAirport = function (search_result: object) {
    this.model['end_airport'] = (search_result['no'] != '' ? search_result['no'] : '0');
  }

  onChangeAirline = function (search_result: object) {
    this.model['airline_id'] = (search_result['no'] != '' ? search_result['no'] : '0');
  }

  add() {

    if (this.model['flight_name'] == '') {
      alert(this.Flight_Name_Msg);
      return;
    }

    if (this.model['flight_number'] == '') {
      alert(this.Flight_Number_Msg);
      return;
    }

    if (this.model['start_airport'] == '0') {
      alert(this.Start_Airport_Msg);
      return;
    }

    if (this.model['end_airport'] == '0') {
      alert(this.End_Airport_Msg);
      return;
    }

    if (this.data_model['dep_time_hr'] == '' || this.data_model['dep_time_mm'] == '' || 
      this.data_model['dep_time_per'] == '') {
        alert(this.Depart_Time_Msg);
        return;
    }

    if (this.data_model['arr_time_hr'] == '' || this.data_model['arr_time_mm'] == '' || 
      this.data_model['arr_time_per'] == '') {
        alert(this.Arrival_Time_Msg);
        return;
    }

    if (this.data_model['flight_start_date'] == undefined) {
      alert(this.Start_Date_Msg);
      return;
    }

    if (this.data_model['flight_end_date'] == undefined) {
      alert(this.End_Date_Msg);
      return;
    }

    let chx_sunday = document.getElementById('chx_sunday') as HTMLInputElement;
    let chx_monday = document.getElementById('chx_monday') as HTMLInputElement;
    let chx_tuesday = document.getElementById('chx_tuesday') as HTMLInputElement;
    let chx_wednesday = document.getElementById('chx_wednesday') as HTMLInputElement;
    let chx_thursday = document.getElementById('chx_thursday') as HTMLInputElement;
    let chx_friday = document.getElementById('chx_friday') as HTMLInputElement;
    let chx_saturday = document.getElementById('chx_saturday') as HTMLInputElement;

    if (!chx_sunday.checked && !chx_monday.checked && !chx_tuesday.checked && !chx_wednesday.checked && 
      !chx_thursday.checked && !chx_friday.checked && !chx_saturday.checked) {
        alert(this.Operating_Days_Msg);
        return;
    }

    if (this.model['ticket_num'] == '') {
      alert(this.Ticket_Num_Msg);
      return;
    }

    if (this.model['adult_price'] == '' || isNaN(Number(this.model['adult_price']))) {
      alert(this.Adult_Price_Msg);
      return;
    }

    if (this.model['child_price'] == '' || isNaN(Number(this.model['child_price']))) {
      alert(this.Child_Price_Msg);
      return;
    }

    if (this.model['infant_price'] == '' || isNaN(Number(this.model['infant_price']))) {
      alert(this.Infant_Price_Msg);
      return;
    }

    let values = [];
    let obj;

    this.model['flight_start_date'] = (this.data_model['flight_start_date'].getFullYear() + '-' +
      (this.data_model['flight_start_date'].getMonth() + 1) + '-' + 
      this.data_model['flight_start_date'].getDate());

    this.model['flight_end_date'] = (this.data_model['flight_end_date'].getFullYear() + '-' +
      (this.data_model['flight_end_date'].getMonth() + 1) + '-' + 
      this.data_model['flight_end_date'].getDate());

    this.model['depart_time'] = this.data_model['dep_time_hr'] + ":" + this.data_model['dep_time_mm'] + 
      " " + this.data_model['dep_time_per'];

    this.model['arrival_time'] = this.data_model['arr_time_hr'] + ":" + this.data_model['arr_time_mm'] + 
      " " + this.data_model['arr_time_per'];

    let weekday = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    let flight_date = this.data_model['flight_start_date'];
    let date_list = [];
    let flight_day = "";

    console.log("flight_start_date: " + this.data_model['flight_start_date']);
    console.log("flight_end_date: " + this.data_model['flight_end_date']);
    while (flight_date <= this.data_model['flight_end_date']) {
      flight_day = weekday[flight_date.getDay()];

      if ((flight_day == "Sunday" && chx_sunday.checked) || (flight_day == "Monday" && chx_monday.checked) || 
        (flight_day == "Tuesday" && chx_tuesday.checked) || (flight_day == "Wednesday" && chx_wednesday.checked) || 
        (flight_day == "Thursday" && chx_thursday.checked) || (flight_day == "Friday" && chx_friday.checked) || 
        (flight_day == "Saturday" && chx_saturday.checked)) 

        date_list.push({ 'flight_date': flight_date.getFullYear() + '-' + 
          (flight_date.getMonth() + 1 < 10 ? '0' : '') + (flight_date.getMonth() + 1) + 
          '-' + (flight_date.getDate() < 10 ? '0' : '') + flight_date.getDate(), 'flight_day': flight_day });
      
      flight_date.setDate(flight_date.getDate() + 1);
      flight_date.setHours(0, 0, 0);
      console.log("date_f: " + flight_date);
    }
    console.log(date_list);

    let exist = false;
    for (let index = 0; index < date_list.length; index++) {

      exist = false;
        
      for (let count = 0; count < this.flight_list.length; count++) {

        if (this.flight_list[count]['flight_date'] == date_list[index]['flight_date']) {
          console.log("flight_date: " + this.flight_list[count]['flight_date']);
          console.log("date: " + date_list[index]['flight_date']);

          exist = true;

          values.push({ 
            'table_name': this.model['table_name'], 'flight_id': this.flight_list[count]['flight_id'], 
            'flight_no': this.model['flight_no'], 'flight_name': this.model['flight_name'], 
            'flight_number': this.model['flight_number'], 'start_airport': this.model['start_airport'], 
            'end_airport': this.model['end_airport'], 'depart_time': this.model['depart_time'], 
            'arrival_time': this.model['arrival_time'], 'flight_start_date': this.model['flight_start_date'], 
            'flight_end_date': this.model['flight_end_date'], 'flight_day': date_list[index]['flight_day'], 
            'flight_date': date_list[index]['flight_date'], 'restriction': this.model['restriction'], 
            'ticket_num': this.model['ticket_num'], 'airline_id': this.model['airline_id'], 
            'return_required': ((document.getElementById('return_required') as HTMLInputElement).checked ? '1' : '0'),
            'adult_price': this.model['adult_price'], 'adult_group_price': this.model['adult_group_price'], 
            'child_price': this.model['child_price'], 'child_group_price': this.model['child_group_price'], 
            'infant_price': this.model['infant_price'], 'infant_group_price': this.model['infant_group_price'], 
            'return_perc': this.model['return_perc'], 'return_group_perc': this.model['return_group_perc'], 
            'flag': 'update', 'key': 'flight_id', 'comment': this.model['comment']
          });
          this.flight_list[count]['flag'] = 'update';

          for (let count2 = 0; count2 < this.cc_list.length; count2++) {

            if (this.cc_list[count2]['cc_date'] == date_list[index]['flight_date']) {

              // update cost center to values
              this.cc_list[count2]['flag'] = 'update';
              values.push({
                'table_name': this.cc_model['table_name'], 'cc_id': this.cc_list[count2]['cc_id'], 
                'cc_number': this.model['flight_number'], 'cc_name': this.model['flight_name'] + " - " + 
                this.model['flight_number'] + " - " + date_list[index]['flight_date'], 
                'cc_name_en': this.model['flight_name'] + " - " + this.model['flight_number'] + " - " + 
                date_list[index]['flight_date'], 'cc_desc': this.model['flight_name'] + " - " + 
                this.model['flight_number'] + " - " + date_list[index]['flight_date'], 
                'cc_date' : date_list[index]['flight_date'], 'key': 'cc_id', 
                'flag': this.cc_list[count2]['flag'], 'comment': this.model['flight_name'] + " - " + 
                this.model['flight_number'] + " - " + date_list[index]['flight_date']
              });
              
              break;
            }
          }

          break;
        }
      }

      if (!exist) {
        console.log("date: " + date_list[index]['flight_date']);

        values.push({ 
          'table_name': this.model['table_name'], 'flight_id': '0', 
          'flight_no': this.model['flight_no'], 'flight_name': this.model['flight_name'], 
          'flight_number': this.model['flight_number'], 'start_airport': this.model['start_airport'], 
          'end_airport': this.model['end_airport'], 'depart_time': this.model['depart_time'], 
          'arrival_time': this.model['arrival_time'], 'flight_start_date': this.model['flight_start_date'], 
          'flight_end_date': this.model['flight_end_date'], 'flight_day': date_list[index]['flight_day'], 
          'flight_date': date_list[index]['flight_date'], 'restriction': this.model['restriction'], 
          'ticket_num': this.model['ticket_num'], 'airline_id': this.model['airline_id'], 
          'return_required': ((document.getElementById('return_required') as HTMLInputElement).checked ? '1' : '0'),
          'adult_price': this.model['adult_price'], 'adult_group_price': this.model['adult_group_price'], 
          'child_price': this.model['child_price'], 'child_group_price': this.model['child_group_price'], 
          'infant_price': this.model['infant_price'], 'infant_group_price': this.model['infant_group_price'], 
          'return_perc': this.model['return_perc'], 'return_group_perc': this.model['return_group_perc'], 
          'flag': 'new', 'key': 'flight_id', 'comment': this.model['comment']
        });

        // add cost center to values
        values.push({
          'table_name': this.cc_model['table_name'], 'cc_id': '0', 
          'cc_number': this.model['flight_number'], 'cc_name': this.model['flight_name'] + " - " + 
          this.model['flight_number'] + " - " + date_list[index]['flight_date'], 
          'cc_name_en': this.model['flight_name'] + " - " + this.model['flight_number'] + " - " + 
          date_list[index]['flight_date'], 'cc_desc': this.model['flight_name'] + " - " + 
          this.model['flight_number'] + " - " + date_list[index]['flight_date'], 
          'cc_date' : date_list[index]['flight_date'], 'key': 'cc_id', 'flag': 'new', 
          'comment': this.model['flight_name'] + " - " + this.model['flight_number'] + " - " + 
          date_list[index]['flight_date']
        });
      }
    }
    
    console.log(this.flight_list);
    // delete flight
    this.flight_list.forEach(element => {
      if (element.flag == undefined) {
        values.push({
          'table_name': this.model['table_name'], 'flight_id': element.flight_id,
          'key': 'flight_id', 'flag': 'delete'
        });
      }
    });

    // delete cost center
    this.cc_list.forEach(element => {
      if (element.flag == undefined) {
        values.push({
          'table_name': this.cc_model['table_name'], 'cc_id': element.cc_id,
          'key': 'cc_id', 'flag': 'delete'
        });
      }
    });
    console.log(values);
    if (this.model['flight_id'] == '0') 
      obj = {
        cmd: 'add', values: values, pk: 'flight_no', id: 'flight_no', main_table: 'flight',
        prefix: ''
      };
    
    else 
      obj = { cmd: 'updateAdv', values: values };
      
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        if (data.status['type'] == 'success') {

          let result = data.status['msg'];
          let values2 = [];
          let where = [];

          // get the id of the added flight and cost center 
          for (let index = 0; index < date_list.length; index++) {

            for (let count = 0; count < result.length; count++) {

              if (result[count]['flight_id'] == '0' && result[count]['table_name'] == this.model['table_name'] && 
                result[count]['flight_date'] == date_list[index]['flight_date']) {
                  where.push({ 'flight_id': result[count]['id'] });
              }
              else if (result[count]['cc_id'] == '0' && result[count]['table_name'] == this.cc_model['table_name'] && 
                result[count]['cc_date'] == date_list[index]['flight_date']) {
                  values2.push({ 'table_name': this.model['table_name'], 'cost_center': result[count]['id'] });
              }
            }
          }
          
          if (values2.length > 0) {
            
            // update the cost center field in flight
            obj = { cmd: 'update', values: values2, where: where };
            this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
              .subscribe(data => {
                //console.log(data);
                this.applicationConstants.appComp.hideBusyCursor();

                if (data.status['type'] == 'success') {
                  alert(this.Success_Msg);
                  this.router.navigate(['sub_menu/13/flight_list']);
                }
                else 
                  alert(this.Error_Msg);
                
              });
          }
        }
        else
          alert(this.Error_Msg);

      });
  }

}
